import { forwardRef, useEffect, useLayoutEffect, useId, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import Input from './Input'
import 'react-datepicker/dist/react-datepicker.css'
import './fields.css'
const parseDate = value => {
    if (!/^\d{4,}-\d{2}-\d{2}$/.test(String(value || ''))) return null
    const [year, month, day] = String(value).split('-').map(Number)
    const date = new Date(0)
    date.setFullYear(year, month - 1, day)
    date.setHours(0, 0, 0, 0)
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null
}
const DateInput = forwardRef(function DateInput({ type = 'date', className = '', id, error, helperText, ...props }, ref) {
    const generatedId = useId()
    const native = useRef(null)
    const picker = useRef(null)
    const [, refresh] = useState(0)
    const fieldId = id || generatedId
    const [inheritedDisabled, setInheritedDisabled] = useState(false)
    useLayoutEffect(() => { setInheritedDisabled(!!native.current?.matches(':disabled')) }, [props.disabled])
    useEffect(() => {
        const form = native.current?.form
        const reset = () => window.setTimeout(() => refresh(version => version + 1), 0)
        form?.addEventListener('reset', reset)
        return () => form?.removeEventListener('reset', reset)
    }, [])
    // Month/time and the explicitly configured mobile datetime input keep their native semantics.
    if (type !== 'date') return <Input {...props} error={error} helperText={helperText} id={id} type={type} ref={ref} className={'uiDateInput ' + className} />
    return <span className="uiDatePickerField">
        <input {...props} type="date" id={fieldId + '-native'} aria-hidden="true" aria-label={undefined} aria-labelledby={undefined} tabIndex={-1} className="uiNativeBacking" ref={element => { native.current = element; if (typeof ref === 'function') ref(element); else if (ref) ref.current = element }} onChange={event => { props.onChange?.(event); refresh(version => version + 1) }} onFocus={event => { picker.current?.setFocus(); props.onFocus?.(event) }} />
        <DatePicker ref={picker} id={fieldId} selected={parseDate(props.value !== undefined ? props.value : native.current?.value ?? props.defaultValue)} minDate={parseDate(props.min)} maxDate={parseDate(props.max)} disabled={props.disabled || inheritedDisabled} readOnly={props.readOnly} dateFormat="yyyy-MM-dd" placeholderText={props.placeholder} ariaLabelledBy={props['aria-labelledby']} portalId="datepicker-portal" customInput={<Input error={error} helperText={helperText} aria-label={props['aria-label']} aria-describedby={props['aria-describedby']} className={'uiDateInput ' + className} />} onBlur={props.onBlur} onChange={date => {
            if (native.current.matches(':disabled') || props.readOnly) return
            const value = date ? [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-') : ''
            Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(native.current, value)
            native.current.dispatchEvent(new Event('input', { bubbles: true }))
            native.current.dispatchEvent(new Event('change', { bubbles: true }))
        }} />
    </span>
})
DateInput.uiField = true
export default DateInput
